import { useDispatch } from "react-redux";

import { useQuery } from "@tanstack/react-query";

import { apiThatThrows } from "containers/Request";
import { ApiQueryParams, ApiResponse } from "types/api";

import { transformVariantPublications } from "./transformers";
import { TiVoPublications, VariantPublications } from "./types";

export const usePublications = (
  platformId: string,
  queryParams?: ApiQueryParams
) => {
  const dispatch = useDispatch();
  return useQuery<
    ApiResponse<VariantPublications[]>,
    Error,
    ApiResponse<TiVoPublications[]>
  >({
    queryKey: ["publications", queryParams, platformId],
    queryFn: () =>
      dispatch(
        apiThatThrows.getTiVoPublications.action({
          params: { platformId },
          queryParams,
        })
      ),
    select: ({ results, ...rest }) => {
      return {
        ...rest,
        results: transformVariantPublications(results, platformId),
      };
    },
    enabled: Boolean(platformId),
  });
};
